/* Launch cleanup: hide decision-only and placeholder items; keep them on our side for later. */
(function () {
  var HIDE_TEXT = ['Review', 'About', 'Close-up lab', 'Morning review', 'Explore tagline options', 'Compare all tagline options', 'Meet Sarah'];
  var BLOCK_ROUTES = ['/review', '/copy', '/about', '/closeup', '/cast', '/library'];
  function route() {
    var h = (location.hash || '').slice(1);
    if (h === '/ingredients' || h.indexOf('/ingredients') === 0) { location.replace('/pages/ingredients'); return; }
    for (var i = 0; i < BLOCK_ROUTES.length; i++) if (h === BLOCK_ROUTES[i] || h.indexOf(BLOCK_ROUTES[i] + '?') === 0) { location.hash = '#/'; return; }
  }
  function sweep() {
    var root = document.getElementById('root'); if (!root) return;
    gallery();
    root.querySelectorAll('a,button').forEach(function (el) {
      var t = (el.textContent || '').trim();
      for (var i = 0; i < HIDE_TEXT.length; i++) {
        if (t.toLowerCase() === HIDE_TEXT[i].toLowerCase() || t.indexOf(HIDE_TEXT[i]) === 0 && t.length < 40 || t.replace(/^\W+/, '') === HIDE_TEXT[i]) { el.style.display = 'none'; }
      }
    });
    root.querySelectorAll('div,section').forEach(function (el) {
      if (el.dataset.lxh) return;
      var t = (el.textContent || '');
      if (t.indexOf('NEW / SKULL OILS') === 0 && t.length < 400) { el.style.display = 'none'; el.dataset.lxh = 1; }
    });
    root.querySelectorAll('.lx-skull-wrap').forEach(function (e) { e.style.display = 'none'; });
    // Sarah placeholder block
    root.querySelectorAll('section,div').forEach(function (el) {
      var t = el.textContent || '';
      if (!el.dataset.lxh && t.indexOf('THE FACE OF LUXUS') === 0 && t.length < 700) { el.style.display = 'none'; el.dataset.lxh = 1; }
    });
  }

  var EV = {
    'Miss Universe Canada': ['lx-muc-0769.jpg','lx-muc-0845.jpg'],
    'Rock the Runway': ['lx-rtr-group4.jpg']
  };
  function gallery() {
    var root = document.getElementById('root'); if (!root) return;
    root.querySelectorAll('article.luxus-event-card').forEach(function (card) {
      var h = card.querySelector('h3'); if (!h) return;
      var imgs = EV[(h.textContent || '').trim()]; if (!imgs) return;
      var slot = card.querySelector('.event-film-slot'); if (!slot || slot.dataset.lxg) return;
      var base = (window.__LXA || '');
      var html = '<div class="lx-evg">';
      imgs.forEach(function (f, i) { html += '<a href="' + base + f + '" target="_blank" rel="noopener"><img loading="lazy" src="' + base + f + '" alt="Luxus Cosmetics at ' + h.textContent.trim() + '" class="' + (/rtr-[34]/.test(f) ? 'lx-contain' : '') + '"></a>'; });
      html += '</div><span class="lx-evsoon">MORE PHOTOS + FILM COMING SOON</span>';
      slot.innerHTML = html; slot.dataset.lxg = '1'; slot.removeAttribute('role'); slot.removeAttribute('aria-label');
    });
  }
  window.addEventListener('hashchange', route); route();
  new MutationObserver(sweep).observe(document.documentElement, {childList: true, subtree: true});
  sweep();
})();
